import ProductPageLayout from '@/pages/products/components/ProductPageLayout';

export default function LobsterPage() {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  return (
    <ProductPageLayout>
      <div className="relative">
        {/* Page background */}
        <div className="fixed inset-0 z-0 pointer-events-none">
          
          
        </div>

        {/* Content section */}
              <section className="relative z-10 w-full">
                  {/* Background */}
                  <div className="absolute inset-0 z-0 overflow-hidden">
                      <img
                          src="/images/k2.png"
                          alt="Slide7"
                          className="w-full h-full object-cover object-center blur-md scale-105"
                      />

                      
                      <div className="absolute inset-0 bg-black/50"></div>
                  </div>

          <div className="relative z-10 w-full max-w-[980px] mx-auto px-6 md:px-10 py-10">
            {/* Script tagline */}
            <p className="font-script text-white text-lg md:text-xl text-center mb-4">
              America&#39;s One-Stop-Shop for Seafood
            </p>

            {/* Header Image + H1 - source DOM has image before H1 */}
            <div className="flex flex-col md:flex-row items-start justify-between gap-4 md:gap-8 mb-2">
              <div className="flex-shrink-0 order-2 md:order-1">
                <img
                                  src="/images/lob2.png"
                  alt="Product Header Lobster"
                  className="w-[600px] max-w-full h-auto"
                />
              </div>
              <h1 className="font-heading text-white text-5xl md:text-6xl lg:text-7xl tracking-[0.2em] leading-none uppercase order-1 md:order-2">
                Wholesale<br />LOBSTER
              </h1>
            </div>

            {/* Subheading */}
            <h5 className="font-heading text-white text-lg md:text-xl tracking-[0.15em] leading-snug mb-6 uppercase">
              Wholesale LOBSTER<br />from Finest Kind Seafood LLC
            </h5>

            {/* First paragraph - font_7 equivalent */}
            <p className="text-white text-sm leading-relaxed mb-6">
              Finest Kind Seafood LLC is a world class purveyor of hardshell North American lobsters. We own and operate a state-of-the-art holding facility with substantial live lobster capacity, strategically located to serve the entire Northeast. By result of our premium sourcing and handling practices at FKS, our wholesale lobsters maintain peak freshness and quality from dock to delivery.
            </p>

            {/* Paragraph 2 */}
            <p className="text-white text-[13px] leading-relaxed mb-5">
              FKS North American lobsters are not only the best quality on the market due to our buying directly from the source in Maine and Canada, but are also set at the sharpest prices on the market. Although buying direct also provides a significant impact on our affordable prices, the real impact of this is found in our volume buying power. For many of lobster purveyors out there selling retail – you may find that you are paying more for your wholesale lobsters elsewhere than you would purchasing from us for the very same North American fresh lobster product – and you may find yourself wondering why? How? Well, as is with many of our products, FKS North American lobsters are offered at industry leading competitive prices due to the massive volumes we are able to purchase in bulk. Our volume buying power, in effect, enables us to drive our cost down on this famous delicacy so that we may in turn drive our prices down for our customers.
            </p>

            {/* Paragraph 3 */}
            <p className="text-white text-[13px] leading-relaxed mb-5">
              Finest Kind Seafood LLC Lobster Division didn&#39;t grow from nothing to well over a million pounds a year by luck, rather, we climbed our way up through knowledge and expertise for the trade. Brandon Vieira – our founder – is both a long-standing seafood professional and New England lobster expert. His knowledge of when to buy, how to buy, and how much to buy are why our sales team can move thousands of live lobsters out our doors with full confidence day-in and day-out.
            </p>

            {/* Zoom image + final paragraph */}
            <div className="relative">
              <img
                              src="/images/lob1.png"
                alt="Wholesale Lobster Zoom"
                className="float-right ml-6 mb-4 w-[260px] md:w-[378px] h-auto"
              />
              <p className="text-white text-[13px] leading-relaxed mb-5">
                Our superior quality by result of both buying direct and then handling them with the utmost care in our state-of-the-art facility until point of sale – combined with our extremely competitive prices by result of our substantial volume buying power – are the reasons why the FKS Lobster Division sits on top of the wholesale lobster industry.
              </p>
              <div className="clear-both" />
                      </div>
                      
          </div>
        </section>
      </div>
    </ProductPageLayout>
  );
}